// material
import { IconButton, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";

// ----------------------------------------------------------------------

export default function MoreMenu({ openEditDialog, openDeleteDialog, userRole }) {
  return (
    <>
      {
        userRole?.includes("Delete") && (
          <Tooltip title="Delete" placement="top">
            <IconButton
              onClick={() => {
                openDeleteDialog();
              }}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        )
      }

      {
        userRole?.includes("Edit") && (
          <Tooltip title="Edit" placement="top">
            <IconButton
              onClick={() => {
                openEditDialog();
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip>
        )
      }
    </>
  );
}
